import { graphql } from '../../../../gql'

// This requests the BE to start our authentication process for the users selected network service.
export const GET_CHANNEL_AUTHORIZATION_INFO = graphql(/* GraphQL */ `
  query ChannelAuthorizationInfo($input: ChannelAuthorizationInfoInput!) {
    channelAuthorizationInfo(input: $input) {
      ... on ChannelAuthorizationInfoResponse {
        url
        state
        redirectUri
        codeVerifier
      }
    }
  }
`)
